<template>
  <div class="card">
    <div class="card-body">
      <p>
        <small class="font-weight-bold">{{ $t('dashboard.case') }}</small>
      </p>
      <div
        v-if="error"
        class="text-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
        class="row"
      >
        <Bar
          class="col-6 col-md-2"
          :name="$t('dashboard.case-label.cough')"
          color-one="#18B2BD"
          color-two="#4C2E88"
          :value="caseResult.Cough"
          :total="caseResult.totalSubmission"
        />
        <Bar
          class="col-6 col-md-2"
          :name="$t('dashboard.case-label.diarrhea')"
          color-one="#18B2BD"
          color-two="#4C2E88"
          :value="caseResult.Diarrhea"
          :total="caseResult.totalSubmission"
        />
        <Bar
          class="col-6 col-md-2"
          :name="$t('dashboard.case-label.smell')"
          color-one="#18B2BD"
          color-two="#4C2E88"
          :value="caseResult.LossofSmellorTaste"
          :total="caseResult.totalSubmission"
        />
        <Bar
          class="col-6 col-md-2"
          :name="$t('dashboard.case-label.runny-nose')"
          color-one="#18B2BD"
          color-two="#4C2E88"
          :value="caseResult.RunnyNose"
          :total="caseResult.totalSubmission"
        />
        <Bar
          class="col-6 col-md-2"
          :name="$t('dashboard.case-label.shortness')"
          color-one="#18B2BD"
          color-two="#4C2E88"
          :value="caseResult.ShortnessofBreath"
          :total="caseResult.totalSubmission"
        />
        <Bar
          class="col-6 col-md-2"
          :name="$t('dashboard.case-label.sore-throat')"
          color-one="#18B2BD"
          color-two="#4C2E88"
          :value="caseResult.SoreThroat"
          :total="caseResult.totalSubmission"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { format, sub } from 'date-fns'
import Api from '@/utils/Api'
import Bar from '@/components/chart/Bar.vue'

export default {
  components: {
    Bar
  },

  props: {
    filters: {
      type: Object,
      default: () => ({
        period: 'daily',
        startDate: sub(new Date(), { days: 30 }),
        endDate: new Date()
      })
    },
    isApply: {
      type: Boolean,
      default: () => (false)
    }
  },

  data: () => ({
    caseResult: {
      Cough: 0,
      Diarrhea: 0,
      LossofSmellorTaste: 0,
      RunnyNose: 0,
      ShortnessofBreath: 0,
      SoreThroat: 0,
      totalSubmission: 0
    },
    error: ''
  }),

  computed: {
    builtFilters () {
      return [
        `period=${this.filters.period}`,
        `startDate=${format(this.filters.startDate, 'yyyy-MM-dd')}`,
        `endDate=${format(this.filters.endDate, 'yyyy-MM-dd')}`,
        ...this.filters.organization.map(organization => `organization=${organization}`),
        ...this.filters.workLocation.map(workLocation => `workLocation=${workLocation}`),
        ...this.filters.employee.map(employee => `employeeType=${employee}`),
        ...this.filters.contractors.map(contractors => `contractorId=${contractors}`),
        ...this.filters.risk.map(risk => `risk=${risk}`)
      ].join('&')
    }
  },

  watch: {
    'filters.contractors': {
      deep: true,
      immediate: true,
      handler: 'fetch'
    },
    isApply: {
      deep: true,
      immediate: true,
      handler: 'fetch'
    }
  },

  created () {
    this.fetch()
  },

  methods: {
    async fetch () {
      try {
        this.error = ''
        const { data } = await Api.dashboard.case(this.builtFilters)
        this.caseResult = data
      } catch {
        this.error = 'Error'
      }
    }
  }
}
</script>
